module.exports = __webpack_public_path__ + "img/tank.d26a85ee.gif";